/**
 * Type guard to check for an object with a specific numeric HTTP status.
 */
export const hasHttpStatus = (
  err: unknown,
  status: number,
): err is { status: number } =>
  err !== null &&
  typeof err === 'object' &&
  'status' in err &&
  (err as { status: unknown }).status === status;
